module.exports = __webpack_public_path__ + "static/agus2-9112deeb6385c944371c326c5d07ca08.svg";